module.exports = __webpack_public_path__ + "static/media/team-cards-social.c213eb7b.jpg";